export default __webpack_public_path__ + "static/media/Sarah-45de0e53b7b2520ebbac35c454b9748a.2c504d1e.png";